import _ from 'lodash';

export default {

    /** Sets a primary phone type if none was provided and there's only 1 number.
     * @param {contactVM} contactVM either submissionVM.baseData.accountHolder, or endorsementVM.policyContact_ML
     */
    setDefaultPrimaryPhone: (contactVM) => {
        if (contactVM.primaryPhoneType.value) {
            return;
        }

        const { homeNumber, workNumber, cellNumber } = contactVM;

        if (homeNumber.value) {
            if (!(workNumber.value || cellNumber.value)) {
                _.set(contactVM, 'primaryPhoneType', 'home');
            }
        } else if (workNumber.value) {
            if (!cellNumber.value) {
                _.set(contactVM, 'primaryPhoneType', 'work');
            }
        } else if (cellNumber.value) {
            _.set(contactVM, 'primaryPhoneType', 'mobile');
        }
    },

    /** Returns contact's primary phone number
     * @param {contact} contact to get its primary phone.
     * @returns {phoneNumber} contact primary phone.
     */
    getPrimaryPhone: (contact)=> {
        switch (contact.primaryPhoneType) {
            case 'home' :
                return contact.homeNumber;
            case 'work' :
                return contact.workNumber;
            case 'mobile' :
                return contact.cellNumber;
            default :
                return null;
        }
    }
};
